// The focus indicator the new design draws on its own controls: 2px of solid `--ring`, which reaches 3:1 on the
// sidebar, on a selected row and on white. `outline-solid` is spelled out, and neither carries `outline-none`:
// that utility turns the style of every `outline-2` on the element to none, so the ring would not draw at all.

/** A free-standing control: the ring 2px outside it. */
export const FOCUS_RING =
    'focus-visible:outline-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-solid';

/**
 * `FOCUS_RING` on a control classic draws too, which keeps its own focus style there. Written out and not built
 * from `FOCUS_RING`: Tailwind takes its class names from the source as they are spelled.
 */
export const NEW_FOCUS_RING =
    'new:focus-visible:outline-ring new:focus-visible:outline-2 new:focus-visible:outline-offset-2 new:focus-visible:outline-solid';

/** A row of a list, which has no room around it and may sit in a clipping parent: the ring inside the row. */
export const FOCUS_RING_INSET =
    'focus-visible:outline-ring focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-solid';

/** `FOCUS_RING_INSET` on a row classic draws too, written out for the same reason as `NEW_FOCUS_RING`. */
export const NEW_FOCUS_RING_INSET =
    'new:focus-visible:outline-ring new:focus-visible:outline-2 new:focus-visible:-outline-offset-2 new:focus-visible:outline-solid';
